import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleDocs = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(6.9049 2)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_0_45",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 27,
				height: 36,
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path",
					d: "M20.1208 36H6.05666C4.22667 36 3.31168 36 2.58584 35.7128C1.53518 35.2969 0.703311 34.4653 0.287384 33.415C1.28746e-07 32.6894 0 31.7747 0 29.9455V6.05455C0 4.22519 1.28746e-07 3.31053 0.287384 2.58494C0.703358 1.53469 1.53523 0.703113 2.58584 0.287284C3.31168 1.50204e-07 4.22667 0 6.05666 0H13.9139L25.1255 11.2077V11.2077C25.4654 11.5475 25.6354 11.7173 25.766 11.9094C25.9546 12.187 26.0843 12.5004 26.147 12.8301C26.1903 13.0583 26.1903 13.3009 26.19 13.7861C26.1828 23.7921 26.1783 23.8907 26.1781 29.9385C26.1781 31.7725 26.1781 32.6896 25.8906 33.4152C25.4746 34.4654 24.6427 35.297 23.5921 35.7128C22.8663 36 21.9511 36 20.1208 36Z",
					fill: "#3186FF"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_0_45)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_2",
						d: "M20.1208 36H6.05666C4.22667 36 3.31168 36 2.58584 35.7128C1.53518 35.2969 0.703311 34.4653 0.287384 33.415C1.28746e-07 32.6894 0 31.7747 0 29.9455V6.05455C0 4.22519 1.28746e-07 3.31053 0.287384 2.58494C0.703358 1.53469 1.53523 0.703113 2.58584 0.287284C3.31168 1.50204e-07 4.22667 0 6.05666 0H13.9139L25.1255 11.2077V11.2077C25.4654 11.5475 25.6354 11.7173 25.766 11.9094C25.9546 12.187 26.0843 12.5004 26.147 12.8301C26.1903 13.0583 26.1903 13.3009 26.19 13.7861C26.1828 23.7921 26.1783 23.8907 26.1781 29.9385C26.1781 31.7725 26.1781 32.6896 25.8906 33.4152C25.4746 34.4654 24.6427 35.297 23.5921 35.7128C22.8663 36 21.9511 36 20.1208 36Z",
						fill: "#3186FF"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Path_3",
						filter: "url(#filter0_f_0_45)",
						children: /* @__PURE__ */ _jsx("path", {
							d: "M2.25088 36.2864H23.9403V1.10457H2.25088V36.2864Z",
							fillRule: "evenodd",
							clipRule: "evenodd",
							fill: "url(#paint0_linear_0_45)"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_4",
						d: "M25.1669 11.249C24.6541 10.8643 24.0169 10.6364 23.3263 10.6364H16.5331C15.0866 10.6364 13.914 9.46415 13.914 8.01822V0L25.1669 11.249Z",
						fillRule: "evenodd",
						clipRule: "evenodd",
						fill: "#76BBFF"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle",
						d: "M18.4162 21.6818H7.77523C7.09743 21.6818 6.54796 22.2313 6.54796 22.9091C6.54796 23.5869 7.09743 24.1363 7.77523 24.1363H18.4162C19.094 24.1363 19.6434 23.5869 19.6434 22.9091C19.6434 22.2313 19.094 21.6818 18.4162 21.6818Z",
						fill: "white"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_2",
						d: "M15.1423 27.6136H7.77523C7.09743 27.6136 6.54796 28.1631 6.54796 28.8409C6.54796 29.5187 7.09743 30.0682 7.77523 30.0682H15.1423C15.8201 30.0682 16.3696 29.5187 16.3696 28.8409C16.3696 28.1631 15.8201 27.6136 15.1423 27.6136Z",
						fill: "white"
					})
				]
			})]
		}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_0_45",
			x: -10.5491,
			y: -11.6954,
			width: 47.2894,
			height: 60.7818,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					stdDeviation: 6.4,
					result: "effect1_foregroundBlur_0_45"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_0_45",
			x1: 13.0956,
			y1: 9.13991,
			x2: 5.25759,
			y2: 30.3533,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .33,
				stopColor: "#3186FF"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#A9A8FF"
			})]
		})] })]
	})
});
export default SvgGoogleDocs;
